module.exports = __webpack_public_path__ + "static/media/setting.773d37ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/SalonConsultation/assets/setting.svg
// module id = 1085
// module chunks = 0